export default () => ({
	region: '',
	init() {
		this.$watch('region', _ => this.regionChange(_));
		this.$nextTick( () => this.callbackSetup() );
	},
	regionChange(_value) {
		this.$dispatch('show-section', _value);
	},
	callbackSetup() {
		window.EPIC_GEOLOCATION_CALLBACKS = window.EPIC_GEOLOCATION_CALLBACKS || [];
		window.EPIC_GEOLOCATION_CALLBACKS.push(
			(country_code) => this.setRegion(country_code)
		);
	},
	setRegion(country) {
		// Try to find entry for specific country
		let $option = this.$el.querySelector(`[data-countries*="${country}"]`);

		// If there's no entry for the specific country, fallback to all countries
		if ( $option == null ) {
			$option = this.$el.querySelector('[data-countries="*"]');
		}

		if ( $option != null ) {
			this.region = $option.attributes.value.value;
		}
	}
});
